import { Controller } from '@hotwired/stimulus'

export default class UserRegistrationController extends Controller {
  static targets = ['submitButton', 'termsCheckbox', 'emailInput'];

  toggleSubmitButton() {
    const isFormValid = this.termsCheckboxTarget.checked && this.emailInputTarget.checkValidity();
    this.submitButtonTarget.disabled = !isFormValid;
  }
}
